export default "__VITE_ASSET__8TBjiamy__"